import React from "react";

/**
 * Gold filigree divider — horizontal gradient line + centered olive sprig.
 *
 * Use between sections. Inherits the parent's text color but defaults to
 * antique gold (#C5A04D).
 *
 * Props:
 *   width:   max width in px (default 320)
 *   color:   theme — 'gold' | 'oxblood' (default 'gold')
 *   className: extra classes
 */
const COLORS = {
  gold: "#C5A04D",
  oxblood: "#8B1E2C",
};

export const Divider = ({
  width = 320,
  color = "gold",
  className = "",
  testId = "divider",
}) => {
  const stroke = COLORS[color] || COLORS.gold;
  return (
    <div
      data-testid={testId}
      className={`flex items-center justify-center w-full ${className}`}
      style={{ maxWidth: width, marginLeft: "auto", marginRight: "auto" }}
    >
      <div
        className="flex-1 h-px"
        style={{
          background: `linear-gradient(to right, transparent, ${stroke}, ${stroke})`,
          opacity: 0.55,
        }}
        aria-hidden
      />
      <svg
        width="44"
        height="20"
        viewBox="0 0 44 20"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-3"
        aria-hidden
      >
        <g
          fill="none"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* horizontal stem */}
          <path d="M2 10 C 12 6, 32 6, 42 10" />
          {/* 3 leaves */}
          <path d="M14 9 C 11 3, 18 1, 20 7 C 17 10, 14 9, 14 9 Z" />
          <path d="M22 11 C 25 17, 18 19, 18 13 C 20 11, 22 11, 22 11 Z" />
          <path d="M30 9 C 27 3, 34 1, 36 7 C 33 10, 30 9, 30 9 Z" />
          {/* berry */}
          <circle cx="42" cy="10" r="1.2" fill={stroke} stroke="none" />
        </g>
      </svg>
      <div
        className="flex-1 h-px"
        style={{
          background: `linear-gradient(to left, transparent, ${stroke}, ${stroke})`,
          opacity: 0.55,
        }}
        aria-hidden
      />
    </div>
  );
};

export default Divider;
